export default __webpack_public_path__ + "static/T2P_logo-c966bd208d912eb76668291d92ed37d2.png";